import React, { Component } from "react";
import ContactPerson from "../../components/ContactPerson";
import SocialList from "../../components/SocialList";
import CompanyItem from "../../components/CompanyItem";
import { HOST } from "../../constants/Fetch";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loadCompany } from "../../actions/CompanyActions";

function shuffleArray(array) {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

class PageSuccessSubmit extends Component {
  render() {
    const {
      vacancy,
      vacancy: {
        item: { company, contact_person: contactPerson },
      },
    } = this.props;
    const shuffled = shuffleArray(this.props.vacancies);

    return (
      <div className="container container--indentVertical success-container">
        <div className="row">
          <div className="col col--9 colTablet--12 success-content">
            <h1 className="success-title">Ваш отклик отправлен, спасибо!</h1>
            <p className="success-subtitle">
              В ближайшие дни наши сотрудники свяжутся с вами.
            </p>
            <Link to="/vacancies">&lt; Вернуться к списку вакансий</Link>
          </div>

          <div className="col col--3 vacancyCard__col colVertTablet--12">
            {!(company === undefined) && (
              <CompanyItem card={company} inVacancy={true} />
            )}
            {!(contactPerson === undefined) && (
              <React.Fragment>
                {contactPerson && (
                  <ContactPerson
                    person={contactPerson}
                    isInternship={this.props.isInternship}
                  />
                )}
                <SocialList
                  url={HOST + this.props.match.url}
                  title={vacancy.name}
                />
              </React.Fragment>
            )}
            {shuffled && shuffled.length > 1 && (
              <div>
                <h2 className="text text--h3 text--top16">Другие вакансии</h2>
                <div className="text">
                  {shuffled
                    .slice(
                      0,
                      shuffled.length > 2
                        ? shuffled.length - (shuffled.length - 2)
                        : shuffled.length - 1
                    )
                    .map((vacancy, index) => (
                      <p key={`vacancy-${index}`}>
                        <Link to={`vacancy${vacancy.id}`}>{vacancy.name}</Link>
                      </p>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.company.item,
    vacancy: state.vacancy,
    vacancies: state.vacancies.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadCompany }, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PageSuccessSubmit)
);



// WEBPACK FOOTER //
// ./src/pages/PageSuccessSubmit/index.js